<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-sale-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-sale"></div>
                <div class="dialog-body">
                    <div class="buy-detail">
                        <ul class="sale-list">
                            <li class="clearfix"><em class="f-l">商品总价</em><p class="f-r">{{ settle.total }}<em class="icon-m3b"></em></p></li>
                            <li class="clearfix"><em class="f-l">砍价已减</em><p class="f-r">{{ settle.total - settle.now }}<em class="icon-m3b"></em></p></li>
                            <li v-for="(detail,shop) in settle.offer_detail" :key="shop" class="clearfix">
                                <em class="f-l">{{ shop_dic[shop].discount }}</em>
                                <p class="f-r">{{ detail.cut }}<em class="icon-m3b"></em></p>
                            </li>
                            <li v-if="settle.offer > 0" class="clearfix"><p class="f-l">店铺优惠券<em class="shop-ticket"></em></p><p class="f-r">{{ settle.rate || 0 }}<em class="icon-m3b"></em></p></li>
                        </ul>
                        <div class="total clearfix">
                            <em class="f-l">合计</em>
                            <p class="f-r">           
                                {{ settle.now - settle.cut - settle.offer }}<em class="icon-m3b"></em>
                            </p>
                        </div>
                    </div>
                </div>          
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>     
</template>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            shop_dic : shop_group.shop_dic,
            dialogVisible : false,
            settle : () => {},
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },    
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        rate_sum (){
            var ret = 0;
            for(let shop in this.settle.offer_detail){
                ret += this.settle.offer_detail[shop].rate;
            }

            return ret;
        },    
    },      
}
</script>

<style lang="scss" scoped>
/* sale */
.m-sale-modal {
    width: 625px;
    height: 510px;
    background-image: url(~@/assets/images/modal/bg-modal-sale.png);
}

.t-sale {
    width: 516px;
    height: 52px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/modal/title-sale.png);
}

.m-sale-modal .buy-detail ul.sale-list {
    margin: 0 45px;
    padding: 12px 16px 0;
    background-color: #f8f7f3;
    border: 1px solid #ebe9e2;
}

.m-sale-modal ul.sale-list li {
    display: flex;
    justify-content: space-between;
    padding: 0 16px 12px;
    margin-bottom: 12px;
    border-bottom: 1px dashed #ebe9e2;
}

.total{
    position: absolute;
    left: 0;
    bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 72px;

    em{
        font-weight: 700;
        color: #696560;
    }

    p{
        font-weight: 700;
        color: #d33d27;        
    }
}

</style>